module.exports = __webpack_public_path__ + "static/media/004-gmail.d0915bc3.svg";